import {
  Button,
  Flex,
  Table,
  TableContainer,
  TableContainerProps,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
// import {
//   DecisionTypeApproved,
//   DecisionTypePending,
//   DecisionTypeRejected,
//   PendingTransactionApprovalView,
// } from 'types';
import { UserLink } from './AppLink';
import { CurrencyLabel } from './Currency';
import { useAdmin } from 'core';
import { TransactionDecisionResponse } from 'api/bindings/TransactionDecisionResponse';
import { DecisionType } from 'api';

export interface RevisionApprovalTableProps
  extends Omit<TableContainerProps, 'children'> {
  // approvals: PendingTransactionApprovalView[] | undefined;
  approvals: TransactionDecisionResponse[] | undefined;
  onDecisionRequested: (approval: TransactionDecisionResponse) => void;
}

export const RevisionApprovalTable = (props: RevisionApprovalTableProps) => {
  const { approvals, onDecisionRequested, ...other } = props;

  const [userId, isAdmin] = useAdmin();
  // const [modal, setModal] = useState<Omit<DecisionDrawerProps, 'onClose'>>();

  return (
    <>
      <TableContainer {...other}>
        <Table variant={'simple'}>
          <Thead>
            <Tr>
              <Th></Th>
              <Th>#</Th>
              <Th>User</Th>
              <Th>Amount</Th>
              <Th>Approval</Th>
              <Th>Comment</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {!approvals?.length && (
              <Tr>
                <Td colSpan={5}>No Approvers To Display</Td>
              </Tr>
            )}
            {approvals?.map((a, i) => (
              <Tr key={i}>
                <Td>{/* icon goes here  */}</Td>
                <Td>{a.rank.toString()}</Td>
                <Td>
                  <UserLink u={a.user} />
                </Td>
                <Td>
                  <CurrencyLabel value={a.amount} />
                </Td>
                <Td>
                  {(a.decision === DecisionType.Approved && 'Approved') ||
                    (a.decision === DecisionType.Rejected && 'Rejected') ||
                    'Pending'}
                </Td>
                <Td>{a.comment}</Td>
                <Td>
                  <Flex justifyContent={'flex-end'}>
                    {a.decision === DecisionType.Pending &&
                      (userId === a.userId || isAdmin) && (
                        <Button
                          colorScheme="blue"
                          variant="solid"
                          onClick={() => onDecisionRequested(a)}
                        >
                          Approve or Reject
                        </Button>
                      )}
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
